import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1480125446964693'

function loadPixelScript() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
    window.fbq('track', 'PageView')
  }, [])
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Huesos Invencibles',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
